module.exports = __webpack_public_path__ + "assets/img/f3.89517f5d.png";